/**
 * action type constants related to fetching the ISE Calibration
 */
export const FETCH_ISE_CALIBRATION_INFO_REQUEST = "FETCH_ISE_CALIBRATION_INFO_REQUEST";
export const FETCH_ISE_CALIBRATION_INFO_SUCCESS = "FETCH_ISE_CALIBRATION_INFO_SUCCESS";
export const FETCH_ISE_CALIBRATION_INFO_ERROR = "FETCH_ISE_CALIBRATION_INFO_ERROR";
export const CLOSE_ERROR_MESSAGE_POPUP = "CLOSE_ERROR_MESSAGE_POPUP";
export const LEVEL_ORDER = ['Level 1', 'Level 2', 'Level 3', 'Level 4'];

